import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';
import { AuthProvider, useAuth } from './lib/auth';
import { ToastProvider } from './ui/toast';
import './styles.css';

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, staleTime: 15_000, refetchOnWindowFocus: false } },
});

const router = createRouter({
  routeTree,
  context: { auth: undefined! },
  defaultPreload: 'intent',
  scrollRestoration: true,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

function App() {
  const auth = useAuth();
  if (auth.carregando) return <div className="tela-carregando">carregando…</div>;
  return <RouterProvider router={router} context={{ auth }} />;
}

// guarda o root no window: o HMR do Vite reavalia este módulo quando o routeTree é regenerado
const w = window as unknown as { __sgcRoot?: ReturnType<typeof createRoot> };
const root = (w.__sgcRoot ??= createRoot(document.getElementById('root')!));
root.render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
);
